import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Trash2, FolderOpen, Save, Upload } from 'lucide-react';
import { listProjects, createProject, deleteProject } from '@/lib/api';
import { toast } from 'sonner';
import { IDS } from '@/constants/testIds/wizard';

export const ProjectsDialog = ({ open, onOpenChange, currentSnapshot, onLoad }) => {
  const [items, setItems] = useState([]);
  const [saveName, setSaveName] = useState('');

  const load = async () => {
    try {
      const list = await listProjects();
      setItems(list);
    } catch { toast.error('Projektek betoltese sikertelen'); }
  };
  useEffect(() => { if (open) { load(); setSaveName(currentSnapshot?.name || ''); } }, [open]);

  const saveSnapshot = async () => {
    if (!saveName?.trim()) return toast.error('Nev szukseges');
    try {
      await createProject({ ...currentSnapshot, name: saveName });
      toast.success('Projekt mentve');
      await load();
    } catch { toast.error('Mentesi hiba'); }
  };
  const remove = async (id) => {
    try { await deleteProject(id); await load(); toast.success('Torolve'); }
    catch { toast.error('Torles sikertelen'); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FolderOpen className="h-4 w-4 text-primary" /> Projektek</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground">Elmentett projektek kezelese.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-end gap-2">
            <div className="flex-1">
              <Label className="text-xs">Aktualis munkalap mentese</Label>
              <Input value={saveName} onChange={e => setSaveName(e.target.value)} placeholder="Projekt neve" />
            </div>
            <Button onClick={saveSnapshot} data-testid={IDS.projects.save}><Save className="h-4 w-4 mr-1" /> Mentes</Button>
          </div>
          <div className="h-px bg-border" />
          <div className="max-h-96 overflow-y-auto space-y-1" data-testid={IDS.projects.list}>
            {items.length === 0 && <p className="text-xs text-muted-foreground text-center py-4">Nincs mentett projekt.</p>}
            {items.map(p => (
              <div key={p.id} className="flex items-center justify-between p-2 rounded-lg border border-border/60 hover:bg-[rgba(0,255,65,0.04)]">
                <div className="flex flex-col">
                  <span className="text-sm font-medium">{p.name}</span>
                  <span className="text-[10px] text-muted-foreground tabular">{p.operation} • {new Date(p.updated_at).toLocaleString('hu-HU')}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Button size="sm" variant="secondary" onClick={() => onLoad(p)} data-testid={IDS.projects.load}><Upload className="h-3.5 w-3.5 mr-1" />Betoltes</Button>
                  <Button size="icon" variant="ghost" onClick={() => remove(p.id)} data-testid={IDS.projects.delete}><Trash2 className="h-3.5 w-3.5 text-red-400" /></Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectsDialog;
